import { render, staticRenderFns } from "./CoursewareContentLinks.vue?vue&type=template&id=b49737e0&"
import script from "./CoursewareContentLinks.vue?vue&type=script&lang=js&"
export * from "./CoursewareContentLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports